import { LogOut, Settings } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";

import { IgIconButton, IgTooltip, IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";
import { useIsAdmin } from "@src/api/user-auths/is-admin";
import { useLogout } from "@src/api/user-auths/logout";
import { StandardRoutes } from "@src/components/Utils/routes";
import { IgPageContentBreadcrumbs } from "@src/utils/IgPageContentBreadcrumbs";

export const IgPageContentTopBar = () => {
  const navigate = useNavigate();
  const logout = useLogout();
  const isAdmin = useIsAdmin();
  return (
    <Grid
      item
      container
      direction={"row"}
      rowSpacing={4}
      columnSpacing={2}
      alignItems={"center"}
      sx={{ flexShrink: 0 }}
      justifyContent={"space-between"}
      wrap={"nowrap"}
    >
      <Grid
        item
        columnSpacing={1}
        container
        direction={"row"}
        alignItems={"center"}
      >
        {/*<SideNavCollapseControl />*/}
        <Grid item>
          <IgPageContentBreadcrumbs />
        </Grid>
      </Grid>
      <Grid
        item
        container
        direction={"row"}
        alignItems={"center"}
        justifyContent={"flex-end"}
        columnSpacing={2}
      >
        <Grid item>
          <IgTooltip
            title={
              <IgTypography variant={"body2"}>
                Settings{" "}
                {isAdmin && (
                  <IgTypography
                    sx={{ border: ".5px solid white", borderRadius: "2px" }}
                    variant={"body2"}
                  >
                    Ctrl+S
                  </IgTypography>
                )}
              </IgTypography>
            }
          >
            <IgIconButton
              onClick={() => {
                void navigate(StandardRoutes().settings.path);
              }}
            >
              <Settings size={16} />
            </IgIconButton>
          </IgTooltip>
        </Grid>
        <Grid item>
          <IgTooltip title={"Log out"}>
            <IgIconButton
              onClick={() => {
                logout.mutate();
              }}
            >
              <LogOut size={16} />
            </IgIconButton>
          </IgTooltip>
        </Grid>
      </Grid>
    </Grid>
  );
};
